import { useRouter } from 'next/router'

export default function Container ({ children, defaultKey, setIsLoading }) {
  const router = useRouter()

  const tabs = [
    {
      key: 'my-orders',
      tab: 'Active Orders'
    },
    {
      key: 'past-orders',
      tab: 'Past Orders'
    }
  ]

  const onChangeBBTabs = (value) => {
    if (defaultKey !== value) {
      setIsLoading(true)
      router.push(value)
    }
  }

  return children({ tabs, onChangeBBTabs })
}
